import styled from 'styled-components';

export const StyledSolutionList = styled.section`
    padding: 120px 0 120px;
    position: relative;

    .masonary-row {
        margin-top: 60px;

        @media(max-width: 767px) {
            margin-top: 40px;
        }
    }

    .col-md-4 {
        margin-bottom: 30px;

        @media(max-width: 767px) {
            margin-bottom: 0;

            &:nth-of-type(4n-2) {
                transform: translateY(0);
            }

            &:nth-of-type(4n-1) {
                transform: translateY(0);
            }
        }

        &:nth-of-type(3n + 2) {
            transform: translateY(50px);
        }

        &:nth-of-type(3n) {
            transform: translateY(20px);
        }
    }
`;
